import React from 'react'
import {MBContentBodyDivider} from '../../Atoms/Dividers'
import {PasswordForm, PasswordFormProps} from './PasswordForm'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {MBContentSubTitleTypography} from '../../Atoms/Typographies'
import {PIMCard} from '../../Atoms/Cards/PIMCard'

type PasswordInputContentProps = {
  title: string
  topMessage: string
} & PasswordFormProps
export const PasswordInputContent: React.VFC<PasswordInputContentProps> = (props) => {
  return (
    <PIMCard
      headerProps={{title: props.title}}
      testId={'block-password-input-content'}
    >
      <PIMStack
        spacing={'18px'}
        divider={<MBContentBodyDivider/>}
        showEndDivider
      >
        <MBContentSubTitleTypography>
          {props.topMessage}
        </MBContentSubTitleTypography>

        <PasswordForm
          showRequiredBadge={props.showRequiredBadge}
          password={props.password}
          onChange={(password: string): void => props.onChange(password)}
          passwordErrors={props.passwordErrors}
          defaultShowPasswordChecked={props.defaultShowPasswordChecked}
          onCheckboxChange={(checked: boolean): void => props.onCheckboxChange(checked)}
        />
      </PIMStack>
    </PIMCard>
  )
}
